// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonTooltip_button__2scvD"};